<template>

	<div>

		<div :class="enabled ? blurClass : ''">
			<slot></slot>
		</div>

		<div class="modal-mask"
			 v-if="enabled">
			<div class="modal-wrapper">
				<div class="modal-container"
				>
					<div :class="introTextClass"
						 style="padding-bottom: 10px">{{ !multipleLocationsFound ? introText :
													  multipleLocationsFoundText }}
					</div>

					<div :class="errorTextClass"
						 style="padding-bottom: 10px"
						 v-if="errorText">{{ errorText }}
					</div>

					<div class="radar-spinner center"
						 v-if="isGettingLocation && !errorText && !multipleLocationsFound">
						<div class="circle">
							<div class="circle-inner-container">
								<div class="circle-inner"></div>
							</div>
						</div>

						<div class="circle">
							<div class="circle-inner-container">
								<div class="circle-inner"></div>
							</div>
						</div>

						<div class="circle">
							<div class="circle-inner-container">
								<div class="circle-inner"></div>
							</div>
						</div>

						<div class="circle">
							<div class="circle-inner-container">
								<div class="circle-inner"></div>
							</div>
						</div>
					</div>

					<button :class="buttonClass"
							@click="onLocation"
							v-show="!isGettingLocation && !multipleLocationsFound">{{ buttonText }}
					</button>

					<div v-if="multipleLocationsFound">

						<slot name="locations"></slot>

					</div>

				</div>
			</div>
		</div>


	</div>


</template>

<script>
    export default {
        props: {
            enabled: Boolean,
            introText: String,
            introTextClass: String,
            errorTextClass: String,
            buttonText: String,
            buttonClass: String,
            multipleLocationsFoundText: String,
            multipleLocationsFound: Boolean
        },
        data() {
            return {
                blurClass: "blur-content",
                isGettingLocation: false,
                errorText: ""
            };
        },
        mounted() {
            if (detectIE()) {
                this.blurClass = "blur-content-ie";
            }
        },
        computed: {
            multipleLocations: function () {
                return this.foundLocations.length > 0;
            }
        },
        methods: {
            onLocation: function () {
                this.errorText = null;

                this.isGettingLocation = true;
                this.getLocation({
                    enableHighAccuracy: true, //defaults to false
                    timeout: Infinity, //defaults to Infinity
                    maximumAge: 0 //defaults to 0

                })
                    .then(coordinates => {
                        this.$emit('location', {
                            coordinates: coordinates,
                            error: null
                        });
                    }).catch(reason => {
                    // no position access
                    // no browser support
                    this.$emit('location', {
                        coordinates: null,
                        error: reason
                    });


                });
            },

            setError(error) {
                this.errorText = error;
                this.isGettingLocation = false;
            },

            // setFoundLocations(locations) {
            //     this.foundLocations = locations;
            //     this.isGettingLocation = false;
            // },
            //
            // onSelectLocation(selectedId) {
            //     this.$emit('locationSelected', selectedId);
            // },

            getLocation(options = {}, forceReject = false) {
                return new Promise((resolve, reject) => {
                    if (forceReject) {
                        reject('reject forced for testing purposes')
                        return
                    }
                    if (!this._isAvailable()) {
                        reject('no browser support')
                    } else {
                        window.navigator.geolocation.getCurrentPosition(
                            position => {
                                resolve({
                                    lat: position.coords.latitude,
                                    lng: position.coords.longitude,
                                    altitude: position.coords.altitude,
                                    altitudeAccuracy: position.coords.altitudeAccuracy,
                                    accuracy: position.coords.accuracy
                                })
                            },
                            () => {
                                reject('no position access')
                            },
                            options
                        )
                    }
                })
            },

            _isAvailable() {
                return 'geolocation' in window.navigator
            }
        }
    }


    /**
     * detect IE
     * returns version of IE or false, if browser is not Internet Explorer
     */
    function detectIE() {
        var ua = window.navigator.userAgent;

        // Test values; Uncomment to check result …

        // IE 10
        // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';

        // IE 11
        // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';

        // Edge 12 (Spartan)
        // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';

        // Edge 13
        // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';

        var msie = ua.indexOf('MSIE ');
        if (msie > 0) {
            // IE 10 or older => return version number
            return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
        }

        var trident = ua.indexOf('Trident/');
        if (trident > 0) {
            // IE 11 => return version number
            var rv = ua.indexOf('rv:');
            return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
        }

        // var edge = ua.indexOf('Edge/');
        // if (edge > 0) {
        //     // Edge (IE 12+) => return version number
        //     return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
        // }

        // other browser
        return false;
    }
</script>

<style>

	.blur-content {
		-webkit-filter: blur(3px); /* Safari */
		filter: blur(3px);
		-ms-filter: blur(3px);
		filter: progid:DXImageTransform.Microsoft.Blur(pixelradius='3', shadowopacity='0.0');
	}

	.blur-content-ie {
		opacity: 0.2;
	}

	.modal-mask {
		position: fixed;
		z-index: 9998;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		display: table;
	}

	.modal-wrapper {
		display: table-cell;
		vertical-align: middle;
	}

	.modal-container {
		width: 80%;
		margin: 0px auto;
		padding: 20px 30px;
		background-color: #fff;
		border-radius: 2px;
		box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
		transition: all .3s ease;
		font-family: Helvetica, Arial, sans-serif;
	}


	.center {
		margin: auto;
		width: 50%;
	}

	.radar-spinner, .radar-spinner * {
		box-sizing: border-box;
	}

	.radar-spinner {
		height: 60px;
		width: 60px;
		position: relative;
	}

	.radar-spinner .circle {
		position: absolute;
		height: 100%;
		width: 100%;
		top: 0;
		left: 0;
		animation: radar-spinner-animation 2s infinite;
	}

	.radar-spinner .circle:nth-child(1) {
		padding: calc(60px * 5 * 2 * 0 / 110);
		animation-delay: 300ms;
	}

	.radar-spinner .circle:nth-child(2) {
		padding: calc(60px * 5 * 2 * 1 / 110);
		animation-delay: 300ms;
	}

	.radar-spinner .circle:nth-child(3) {
		padding: calc(60px * 5 * 2 * 2 / 110);
		animation-delay: 300ms;
	}

	.radar-spinner .circle:nth-child(4) {
		padding: calc(60px * 5 * 2 * 3 / 110);
		animation-delay: 0ms;
	}

	.radar-spinner .circle-inner, .radar-spinner .circle-inner-container {
		height: 100%;
		width: 100%;
		border-radius: 50%;
		border: calc(60px * 5 / 110) solid transparent;
	}

	.radar-spinner .circle-inner {
		border-left-color: #39b54a;
		border-right-color: #39b54a;
	}

	@keyframes radar-spinner-animation {
		50% {
			transform: rotate(180deg);
		}
		100% {
			transform: rotate(0deg);
		}
	}


</style>